import React, { Component } from "react";
import * as Containers from "../components/containers";
import Logo from "../components/logo";
import FaChevronDown from "react-icons/lib/fa/chevron-down";
import FaPlay from "react-icons/lib/fa/play";
import { SingleThumb } from "../components/single";
import Menu from "../components/menu";
import buildLink from "../functions/buildlink";
import Footer from "../components/footer";
import Posts, { getBySlug } from "../functions/posts";
import Sharers from "../components/sharers";
import { Link } from "react-router-dom";
export class SinglePage extends Component {
  state = {
    player: null,
    showoverlay: true,
    height: 0,
    slug: "",
    width: 0
  };
  constructor(props) {
    super(props);
    this.onReady = this.onReady.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  componentDidMount() {}
  componentDidUpdate() {
    if (this.props.match.params.slug !== this.state.slug) {
      this.setState({
        slug: this.props.match.params.slug
      });
      window.scroll(0, 0);
    }
  }
  onReady(event) {
    this.setState({
      player: event.target
    });
  }
  playVideo() {
    this.state.player.playVideo();
    this.setState({
      showoverlay: false
    });
  }
  componentDidMount() {
    var self = this;
    window.scroll(0, 0);
    setTimeout(function() {
      window.scroll(0, 0);
    }, 1000);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  render() {
    var p = getBySlug(this.props.match.params.slug);
    var f = p.funcionario;
    const opts = {
      height: "390",
      width: "640",
      playerVars: {
        autoplay: 0
      }
    };
    return (
      <Containers.Container classes={["single"]} contentTitle={p.title}>
        <Menu match={this.props.match} />
        <Sharers post={p} />
        <Containers.Section id="mainphoto">
          <div className="mainphoto-edo">{p.state}</div>
          <div
            className="mainphoto-img"
            style={{ backgroundImage: "url(" + p.photo.uri + ")" }}
          />
        </Containers.Section>
        <Containers.Section className="single-entry">
          <h1>{p.title}</h1>
          <div className="date">{p.fecha}</div>
          <div className="date">{p.author}</div>
          {p.content}
        </Containers.Section>
        <Containers.Section className="singles">
          {Posts.map(function(post) {
            if (post.slug == p.slug) {
              return;
            }
            return (
              <SingleThumb
                title={post.title}
                slug={post.slug}
                edo={post.state}
                bg={post.photo.uri}
              />
            );
          })}
        </Containers.Section>
      </Containers.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/single.jsx